import { useMutation, ApolloError } from '@apollo/client'

import { MUTATION_CREATE_COMPANY } from '@libs/apollo/mutations'
import { COMPANYS } from '@libs/apollo/queries'

import { Company, CompanyCreateInput, MutationCreateCompanyArgs } from '@types'

interface Data {
  createCompany?: Company
}

export const useCreateCompany = (): {
  createCompany: (input: CompanyCreateInput) => Promise<Company | undefined>
  loading: boolean
  error: ApolloError | undefined
  data?: Data | null
} => {
  const [createCompany, { loading, error, data }] = useMutation<Data, MutationCreateCompanyArgs>(
    MUTATION_CREATE_COMPANY,
    {
      notifyOnNetworkStatusChange: true,
      awaitRefetchQueries: true,
    },
  )

  const _createCompany = async (input: CompanyCreateInput): Promise<Company | undefined> => {
    try {
      const response = await createCompany({
        variables: { input },
        refetchQueries: [
          {
            query: COMPANYS,
            variables: {
              input: { projectId: input.projectId },
            },
          },
        ],
      })

      if (response.data?.createCompany) {
        return response.data.createCompany
      }
    } catch (error) {
      console.error(error)
    }
  }

  return { createCompany: _createCompany, loading, error, data }
}
